
	import Vue from "vue";

	export default Vue.extend({
		name: "LinearScaleBuilder",
		props: {
			labelFrom: {
				type: String,
				default: "",
			},
			labelTo: {
				type: String,
				default: "",
			},
			labelTextFrom: {
				type: String,
				default: "",
			},
			labelTextTo: {
				type: String,
				default: "",
			},
			disabled: {
				type: Boolean,
				default: true,
			},
			value: {
				type: Object,
				default: () => {
					return {
						minValue: 0,
						maxValue: 0,
						minLabel: "",
						maxLabel: "",
					};
				},
			},
		},
		data() {
			return {
				linearScale: this.value,
			};
		},
		methods: {},
		watch: {
			linearScale: function (nList) {
				this.linearScale = nList;
				this.$emit("input", nList);
			},
		},
	});
